
import { Routes, Route } from "react-router-dom"; // Importa componentes necesarios para la navegación entre páginas
import Cards_apps from "./Apps/Cards"; // Importa el componente Cards
// import Hanoi from "./Sounds/Hanoi"; // Importa el componente Hanoi
// import Frieze from "./Sounds/Frieze"; // Importa el componente Frieze
import Secuenciador from "./Apps/Secuenciador"; // Importa el componente Koch
import LSystems from "./Apps/Lsystems"; // Importa el componente LSystems
import Simetrias from "./Apps/Simetrias";
import Fractalizate from "./Apps/Fractalizate";


export default function Interact() {
  return (
    <>
        <Routes>
          {/* Define las rutas que corresponden a diferentes componentes */}
          <Route path = "/" element={ <Cards_apps/>} /> {/* Ruta para la página principal, carga el componente Cards */}   
          <Route path = "/curvas-fractales" element= <LSystems/>/> {/* Ruta para la página de Koch */}
          <Route path = "/secuenciador" element= <Secuenciador/>/> {/* Ruta para la página de Tiling */}
          <Route path = "/simetrias" element= <Simetrias/>/> {/* Ruta para la página de Tiling */}
          <Route path = "/fractalizate" element= <Fractalizate/>/> {/* Ruta para la página de Tiling */}
        </Routes>
    </>
  );
}

